import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export const LANGUAGE_STORAGE_KEY = "userLanguage";
export const DEFAULT_LANGUAGE = "en";
const SUPPORTED_LANGUAGES = ["en", "gr"];

export const normalizeLanguageCode = (language) => {
    const normalized = String(language || "").trim().toLowerCase();
    return SUPPORTED_LANGUAGES.includes(normalized) ? normalized : DEFAULT_LANGUAGE;
};

export const toUiLanguageCode = (language) =>
    normalizeLanguageCode(language) === "gr" ? "GR" : "EN";

const readCachedDictionary = (cacheKey) => {
    if (typeof window === "undefined") return null;
    const stored = window.localStorage.getItem(cacheKey);
    if (!stored) return null;

    try {
        return JSON.parse(stored);
    } catch {
        window.localStorage.removeItem(cacheKey);
        return null;
    }
};

const hydrateCachedTranslations = (language) => {
    if (typeof window === "undefined") return;

    const publicDictionary = readCachedDictionary(`publicTranslations_${language}`);
    if (publicDictionary) {
        i18n.addResourceBundle(language, "translation", publicDictionary, true, true);
    }

    const authDictionary = readCachedDictionary(`authTranslations_${language}`);
    if (authDictionary) {
        i18n.addResourceBundle(language, "translation", authDictionary, true, true);
    }
};

const storedLanguage =
    typeof window !== "undefined"
        ? window.localStorage.getItem(LANGUAGE_STORAGE_KEY)
        : DEFAULT_LANGUAGE;

const initialLanguage = normalizeLanguageCode(storedLanguage || DEFAULT_LANGUAGE);

if (!i18n.isInitialized) {
    i18n
        .use(initReactI18next)
        .init({
            resources: {
                en: { translation: {} },
                gr: { translation: {} },
            },
            lng: initialLanguage,
            fallbackLng: DEFAULT_LANGUAGE,
            interpolation: { escapeValue: false },
            returnNull: false,
            returnEmptyString: false,
        });
}

hydrateCachedTranslations(initialLanguage);

export default i18n;
